import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MediaMatcher } from "@angular/cdk/layout";
import { CrmService } from "../../../../servicios/crm.service";

@Component({
  selector: "app-config-cuotas-gestor-proyectos",
  templateUrl: "./config-cuotas-gestor-proyectos.component.html",
  styleUrls: ["./config-cuotas-gestor-proyectos.component.css"],
})
export class ConfigCuotasGestorProyectosComponent implements OnInit {
  formCuotas: FormGroup;
  mobileQuery: MediaQueryList;
  valorInicialEspacio: string;
  valorInicialTiempo: string;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ConfigCuotasGestorProyectosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private media: MediaMatcher,
    private crmservice: CrmService
  ) {
    this.mobileQuery = this.media.matchMedia("(max-width: 600px)");
  }

  ngOnInit(): void {
    this.crearFormulario();
    this.cargarDatosIniciales();
  }

  crearFormulario(): void {
    this.formCuotas = this.fb.group({
      espacioDisponible: [0, [Validators.required, Validators.min(0)]],
      tiempoDisponible: [0, [Validators.required, Validators.min(0)]],
    });
  }

  cargarDatosIniciales(): void {
    if (this.data?.cuentaGestorProyectos) {
      const espacioMB =
        this.data.cuentaGestorProyectos.espacioDisponibleEnBytes /
        (1024 * 1024);
      const tiempoHoras =
        this.data.cuentaGestorProyectos.tiempoDisponibleEnMilisegundos /
        (1000 * 60 * 60);

      this.valorInicialEspacio = espacioMB.toFixed(2).replace(".", ",");
      this.valorInicialTiempo = tiempoHoras.toFixed(2).replace(".", ",");

      this.formCuotas.patchValue({
        espacioDisponible: parseFloat(
          this.valorInicialEspacio.replace(",", ".")
        ),
        tiempoDisponible: parseFloat(this.valorInicialTiempo.replace(",", ".")),
      });
    }
  }

  guardar(): void {
    if (this.formCuotas.valid) {
      const idUsuario = this.crmservice.userLogin._id;
      const valores = this.formCuotas.value;
      const idCliente = this.data.cliente._id;
      const cuentaActualizada = {
        ...this.data.cuentaGestorProyectos,
        espacioDisponibleEnBytes: valores.espacioDisponible * 1024 * 1024,
        tiempoDisponibleEnMilisegundos:
          valores.tiempoDisponible * 1000 * 60 * 60,
      };

      this.crmservice
        .actualizarCuentaGestorProyectos(
          idCliente,
          cuentaActualizada,
          idUsuario
        )
        .then((response) => {
          this.dialogRef.close(cuentaActualizada);
        })
        .catch((error) => {
          console.error("Error al actualizar las cuotas:", error);
        });
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  mostrarValorEnHorasYMinutos(): string {
    const horas = this.formCuotas.get("tiempoDisponible").value;
    const horasEnteras = Math.floor(horas);
    const minutos = Math.round((horas - horasEnteras) * 60);
    return `${horasEnteras}h ${minutos}m`;
  }
}
